import { useCallback, useState } from "react";

import { uuidv4 } from "./math";

// note that there is a similar logic in lambda, if updating that logic here
// make sure to update in lambda too
export const formatDocumentFilename = (parsedFilename: string) => {
  const [_, formattedFilename] = parsedFilename.split("-RIBBONRESUME-");
  return formattedFilename;
};

export const parseDocumentFilename = (formattedFilename: string) => {
  const forbiddenChars = /[^0-9a-zA-Z!_\-.*'()]/g;
  // Replace forbidden characters with an underscore
  const sanitized = formattedFilename.replace(forbiddenChars, "_");

  const lastIndex = sanitized.lastIndexOf(".");

  // Replace all "." except the last one with "_"
  const modifiedString = sanitized.replace(/\./g, (match, index) => {
    return index !== lastIndex ? "_" : ".";
  });

  return `${uuidv4()}-RIBBONRESUME-${modifiedString}`;
};

// update the progress by 2 up to 99 in ~1 min
export const useProgress = () => {
  const [progress, setProgress] = useState(0);
  const [timerId, setTimerId] = useState<NodeJS.Timer>();

  const start = useCallback(() => {
    const interval = setInterval(() => {
      setProgress((state) => {
        if (state < 98) {
          return state + 2;
        } else {
          clearInterval(interval);
          return 99;
        }
      });
    }, 1800);
    setTimerId(interval);
  }, []);

  const stop = useCallback(() => {
    clearInterval(timerId);
    setProgress(0);
  }, [timerId]);
  return { progress, start, stop };
};
